import { TopBar } from '@equinor/eds-core-react';
import styled from 'styled-components';
import { spacings } from '../../tokens/spacings';

const StyledTopBar = styled(TopBar)`
  column-gap: ${spacings.X_LARGE};
`;

const StyledHeader = styled(TopBar.Header)`
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: ${spacings.LARGE};
`;

const StyledWordmark = styled.img`
  display: block;
  height: ${spacings.LARGE};
  transform: translateY(3px);
  width: auto;
`;

const StyledLogo = styled.img`
  display: block;
  height: ${spacings.XXX_LARGE};
  width: auto;
`;

export {
  StyledHeader as Header,
  StyledTopBar as TopBar,
  StyledLogo as Logo,
  StyledWordmark as Wordmark,
};
